/**
 * @generated SignedSource<<95dc5da4e4ece2ef865f79f0532c64ea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from 'relay-runtime';
export type ApplicationQueriesGetListOfMatchedCrewQuery$variables = {
  after?: any | null;
  first?: number | null;
  skip: boolean;
  vacancyId: string;
};
export type ApplicationQueriesGetListOfMatchedCrewQuery$data = {
  readonly applicationInviteCross?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly 'id': string;
        readonly 'owner': {
          readonly info: {
            readonly country: {
              readonly isoCode: string;
            };
          } | null;
        };
        readonly ' $fragmentSpreads': FragmentRefs<'ApplicationFragments'>;
      } | null;
    } | null> | null;
  } | null;
};
export type ApplicationQueriesGetListOfMatchedCrewQuery = {
  response: ApplicationQueriesGetListOfMatchedCrewQuery$data;
  variables: ApplicationQueriesGetListOfMatchedCrewQuery$variables;
};

const node: ConcreteRequest = (function () {
  var v0 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'after',
    },
    v1 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'first',
    },
    v2 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'skip',
    },
    v3 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'vacancyId',
    },
    v4 = {
      kind: 'Variable',
      name: 'vacancyId',
      variableName: 'vacancyId',
    },
    v5 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'id',
      storageKey: null,
    },
    v6 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'isoCode',
      storageKey: null,
    },
    v7 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: '__typename',
      storageKey: null,
    },
    v8 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'cursor',
      storageKey: null,
    },
    v9 = {
      alias: null,
      args: null,
      concreteType: 'PageInfo',
      kind: 'LinkedField',
      name: 'pageInfo',
      plural: false,
      selections: [
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'endCursor',
          storageKey: null,
        },
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'hasNextPage',
          storageKey: null,
        },
      ],
      storageKey: null,
    },
    v10 = [
      {
        kind: 'Variable',
        name: 'after',
        variableName: 'after',
      },
      {
        kind: 'Variable',
        name: 'first',
        variableName: 'first',
      },
      v4 /*: any*/,
    ],
    v11 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'name',
      storageKey: null,
    },
    v12 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'avatarUrl',
      storageKey: null,
    },
    v13 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'alts',
      storageKey: null,
    },
    v14 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'perma',
      storageKey: null,
    },
    v15 = [v5 /*: any*/, v11 /*: any*/, v13 /*: any*/, v14 /*: any*/],
    v16 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'createdAt',
      storageKey: null,
    },
    v17 = {
      alias: null,
      args: null,
      concreteType: 'Profile',
      kind: 'LinkedField',
      name: 'owner',
      plural: false,
      selections: [v5 /*: any*/],
      storageKey: null,
    },
    v18 = [v5 /*: any*/, v11 /*: any*/, v14 /*: any*/],
    v19 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'start',
      storageKey: null,
    },
    v20 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'end',
      storageKey: null,
    },
    v21 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'description',
      storageKey: null,
    },
    v22 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'image',
      storageKey: null,
    },
    v23 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'cnISO',
      storageKey: null,
    },
    v24 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'countryName',
      storageKey: null,
    },
    v25 = [
      v5 /*: any*/,
      v19 /*: any*/,
      v20 /*: any*/,
      {
        alias: null,
        args: null,
        kind: 'ScalarField',
        name: 'rotations',
        storageKey: null,
      },
      v21 /*: any*/,
      {
        alias: null,
        args: null,
        concreteType: 'Vessel',
        kind: 'LinkedField',
        name: 'vessel',
        plural: false,
        selections: [
          v5 /*: any*/,
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'imo',
            storageKey: null,
          },
          v11 /*: any*/,
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'grossTonnage',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'operatorName',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            concreteType: 'VesselKind',
            kind: 'LinkedField',
            name: 'kind',
            plural: false,
            selections: v18 /*: any*/,
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'length',
            storageKey: null,
          },
          v22 /*: any*/,
          v23 /*: any*/,
          v24 /*: any*/,
        ],
        storageKey: null,
      },
      {
        alias: null,
        args: null,
        concreteType: 'Duty',
        kind: 'LinkedField',
        name: 'duty',
        plural: false,
        selections: v15 /*: any*/,
        storageKey: null,
      },
      {
        alias: null,
        args: null,
        concreteType: 'Activity',
        kind: 'LinkedField',
        name: 'activities',
        plural: true,
        selections: [
          v5 /*: any*/,
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'label',
            storageKey: null,
          },
          v14 /*: any*/,
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'timesUsed',
            storageKey: null,
          },
        ],
        storageKey: null,
      },
    ];
  return {
    fragment: {
      argumentDefinitions: [v0 /*: any*/, v1 /*: any*/, v2 /*: any*/, v3 /*: any*/],
      kind: 'Fragment',
      metadata: null,
      name: 'ApplicationQueriesGetListOfMatchedCrewQuery',
      selections: [
        {
          condition: 'skip',
          kind: 'Condition',
          passingValue: false,
          selections: [
            {
              alias: 'applicationInviteCross',
              args: [v4 /*: any*/],
              concreteType: 'ApplicationConnection',
              kind: 'LinkedField',
              name: '__ListWithApplicationInviteCross_applicationInviteCross_connection',
              plural: false,
              selections: [
                {
                  alias: null,
                  args: null,
                  concreteType: 'ApplicationEdge',
                  kind: 'LinkedField',
                  name: 'edges',
                  plural: true,
                  selections: [
                    {
                      alias: null,
                      args: null,
                      concreteType: 'Application',
                      kind: 'LinkedField',
                      name: 'node',
                      plural: false,
                      selections: [
                        v5 /*: any*/,
                        {
                          alias: null,
                          args: null,
                          concreteType: 'Profile',
                          kind: 'LinkedField',
                          name: 'owner',
                          plural: false,
                          selections: [
                            {
                              alias: null,
                              args: null,
                              concreteType: 'ProfileInfo',
                              kind: 'LinkedField',
                              name: 'info',
                              plural: false,
                              selections: [
                                {
                                  alias: null,
                                  args: null,
                                  concreteType: 'Country',
                                  kind: 'LinkedField',
                                  name: 'country',
                                  plural: false,
                                  selections: [v6 /*: any*/],
                                  storageKey: null,
                                },
                              ],
                              storageKey: null,
                            },
                          ],
                          storageKey: null,
                        },
                        {
                          args: null,
                          kind: 'FragmentSpread',
                          name: 'ApplicationFragments',
                        },
                        v7 /*: any*/,
                      ],
                      storageKey: null,
                    },
                    v8 /*: any*/,
                  ],
                  storageKey: null,
                },
                v9 /*: any*/,
              ],
              storageKey: null,
            },
          ],
        },
      ],
      type: 'Query',
      abstractKey: null,
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: [v3 /*: any*/, v0 /*: any*/, v1 /*: any*/, v2 /*: any*/],
      kind: 'Operation',
      name: 'ApplicationQueriesGetListOfMatchedCrewQuery',
      selections: [
        {
          condition: 'skip',
          kind: 'Condition',
          passingValue: false,
          selections: [
            {
              alias: null,
              args: v10 /*: any*/,
              concreteType: 'ApplicationConnection',
              kind: 'LinkedField',
              name: 'applicationInviteCross',
              plural: false,
              selections: [
                {
                  alias: null,
                  args: null,
                  concreteType: 'ApplicationEdge',
                  kind: 'LinkedField',
                  name: 'edges',
                  plural: true,
                  selections: [
                    {
                      alias: null,
                      args: null,
                      concreteType: 'Application',
                      kind: 'LinkedField',
                      name: 'node',
                      plural: false,
                      selections: [
                        v5 /*: any*/,
                        {
                          alias: null,
                          args: null,
                          concreteType: 'Profile',
                          kind: 'LinkedField',
                          name: 'owner',
                          plural: false,
                          selections: [
                            {
                              alias: null,
                              args: null,
                              concreteType: 'ProfileInfo',
                              kind: 'LinkedField',
                              name: 'info',
                              plural: false,
                              selections: [
                                {
                                  alias: null,
                                  args: null,
                                  concreteType: 'Country',
                                  kind: 'LinkedField',
                                  name: 'country',
                                  plural: false,
                                  selections: [v6 /*: any*/, v5 /*: any*/, v11 /*: any*/],
                                  storageKey: null,
                                },
                                v5 /*: any*/,
                                {
                                  alias: null,
                                  args: null,
                                  kind: 'ScalarField',
                                  name: 'firstName',
                                  storageKey: null,
                                },
                                {
                                  alias: null,
                                  args: null,
                                  kind: 'ScalarField',
                                  name: 'lastName',
                                  storageKey: null,
                                },
                                {
                                  alias: null,
                                  args: null,
                                  kind: 'ScalarField',
                                  name: 'bio',
                                  storageKey: null,
                                },
                                {
                                  alias: null,
                                  args: null,
                                  kind: 'ScalarField',
                                  name: 'birthDate',
                                  storageKey: null,
                                },
                                v12 /*: any*/,
                                {
                                  alias: null,
                                  args: null,
                                  concreteType: 'Duty',
                                  kind: 'LinkedField',
                                  name: 'primaryDuty',
                                  plural: false,
                                  selections: v15 /*: any*/,
                                  storageKey: null,
                                },
                                {
                                  alias: null,
                                  args: null,
                                  concreteType: 'Profile',
                                  kind: 'LinkedField',
                                  name: 'owner',
                                  plural: false,
                                  selections: [v5 /*: any*/, v16 /*: any*/],
                                  storageKey: null,
                                },
                                {
                                  alias: null,
                                  args: null,
                                  kind: 'ScalarField',
                                  name: 'isHidden',
                                  storageKey: null,
                                },
                                {
                                  alias: null,
                                  args: null,
                                  kind: 'ScalarField',
                                  name: 'yearsOfExperience',
                                  storageKey: null,
                                },
                              ],
                              storageKey: null,
                            },
                            v5 /*: any*/,
                            v16 /*: any*/,
                            {
                              alias: null,
                              args: null,
                              concreteType: 'CertificateInfo',
                              kind: 'LinkedField',
                              name: 'certificateInfos',
                              plural: true,
                              selections: [
                                v5 /*: any*/,
                                {
                                  alias: null,
                                  args: null,
                                  kind: 'ScalarField',
                                  name: 'expires',
                                  storageKey: null,
                                },
                                v17 /*: any*/,
                                {
                                  alias: null,
                                  args: null,
                                  concreteType: 'Certificate',
                                  kind: 'LinkedField',
                                  name: 'certificate',
                                  plural: false,
                                  selections: [
                                    v5 /*: any*/,
                                    v11 /*: any*/,
                                    v13 /*: any*/,
                                    {
                                      alias: null,
                                      args: null,
                                      kind: 'ScalarField',
                                      name: 'priority',
                                      storageKey: null,
                                    },
                                    {
                                      alias: null,
                                      args: null,
                                      kind: 'ScalarField',
                                      name: 'neverExpires',
                                      storageKey: null,
                                    },
                                    {
                                      alias: null,
                                      args: null,
                                      concreteType: 'CertificateKind',
                                      kind: 'LinkedField',
                                      name: 'kind',
                                      plural: false,
                                      selections: v18 /*: any*/,
                                      storageKey: null,
                                    },
                                  ],
                                  storageKey: null,
                                },
                                {
                                  alias: null,
                                  args: null,
                                  concreteType: 'Document',
                                  kind: 'LinkedField',
                                  name: 'document',
                                  plural: false,
                                  selections: [
                                    v5 /*: any*/,
                                    {
                                      alias: null,
                                      args: null,
                                      kind: 'ScalarField',
                                      name: 'urls',
                                      storageKey: null,
                                    },
                                    {
                                      alias: null,
                                      args: null,
                                      kind: 'ScalarField',
                                      name: 'xlarge_urls',
                                      storageKey: null,
                                    },
                                    {
                                      alias: null,
                                      args: null,
                                      concreteType: 'DocumentKind',
                                      kind: 'LinkedField',
                                      name: 'kind',
                                      plural: false,
                                      selections: v18 /*: any*/,
                                      storageKey: null,
                                    },
                                  ],
                                  storageKey: null,
                                },
                              ],
                              storageKey: null,
                            },
                            {
                              alias: null,
                              args: null,
                              concreteType: 'SeaService',
                              kind: 'LinkedField',
                              name: 'seaServices',
                              plural: true,
                              selections: v25 /*: any*/,
                              storageKey: null,
                            },
                            {
                              alias: null,
                              args: null,
                              concreteType: 'Education',
                              kind: 'LinkedField',
                              name: 'educations',
                              plural: true,
                              selections: [
                                v5 /*: any*/,
                                v19 /*: any*/,
                                v20 /*: any*/,
                                v11 /*: any*/,
                                {
                                  alias: null,
                                  args: null,
                                  concreteType: 'EducationKind',
                                  kind: 'LinkedField',
                                  name: 'kind',
                                  plural: false,
                                  selections: v18 /*: any*/,
                                  storageKey: null,
                                },
                              ],
                              storageKey: null,
                            },
                            {
                              alias: null,
                              args: null,
                              concreteType: 'SeaService',
                              kind: 'LinkedField',
                              name: 'seaServicesHighlighted',
                              plural: true,
                              selections: v25 /*: any*/,
                              storageKey: null,
                            },
                            {
                              alias: null,
                              args: null,
                              concreteType: 'Appraisal',
                              kind: 'LinkedField',
                              name: 'appraisals',
                              plural: true,
                              selections: [
                                v5 /*: any*/,
                                {
                                  alias: null,
                                  args: null,
                                  kind: 'ScalarField',
                                  name: 'review',
                                  storageKey: null,
                                },
                                v17 /*: any*/,
                                {
                                  alias: null,
                                  args: null,
                                  concreteType: 'SeaService',
                                  kind: 'LinkedField',
                                  name: 'seaService',
                                  plural: false,
                                  selections: [
                                    v5 /*: any*/,
                                    v19 /*: any*/,
                                    v20 /*: any*/,
                                    {
                                      alias: null,
                                      args: null,
                                      concreteType: 'Vessel',
                                      kind: 'LinkedField',
                                      name: 'vessel',
                                      plural: false,
                                      selections: [v11 /*: any*/, v22 /*: any*/, v23 /*: any*/, v24 /*: any*/, v5 /*: any*/],
                                      storageKey: null,
                                    },
                                    {
                                      alias: null,
                                      args: null,
                                      concreteType: 'Duty',
                                      kind: 'LinkedField',
                                      name: 'duty',
                                      plural: false,
                                      selections: [v5 /*: any*/, v11 /*: any*/],
                                      storageKey: null,
                                    },
                                  ],
                                  storageKey: null,
                                },
                              ],
                              storageKey: null,
                            },
                            {
                              alias: null,
                              args: null,
                              concreteType: 'OrganizationMember',
                              kind: 'LinkedField',
                              name: 'membership',
                              plural: true,
                              selections: [
                                v5 /*: any*/,
                                v16 /*: any*/,
                                {
                                  alias: null,
                                  args: null,
                                  kind: 'ScalarField',
                                  name: 'role',
                                  storageKey: null,
                                },
                                {
                                  alias: null,
                                  args: null,
                                  concreteType: 'Organization',
                                  kind: 'LinkedField',
                                  name: 'organization',
                                  plural: false,
                                  selections: [
                                    v5 /*: any*/,
                                    {
                                      alias: null,
                                      args: null,
                                      kind: 'ScalarField',
                                      name: 'city',
                                      storageKey: null,
                                    },
                                    {
                                      alias: null,
                                      args: null,
                                      concreteType: 'Country',
                                      kind: 'LinkedField',
                                      name: 'country',
                                      plural: false,
                                      selections: [v5 /*: any*/, v6 /*: any*/, v11 /*: any*/],
                                      storageKey: null,
                                    },
                                    v11 /*: any*/,
                                    v21 /*: any*/,
                                    v12 /*: any*/,
                                    {
                                      alias: null,
                                      args: null,
                                      kind: 'ScalarField',
                                      name: 'size',
                                      storageKey: null,
                                    },
                                  ],
                                  storageKey: null,
                                },
                              ],
                              storageKey: null,
                            },
                            {
                              alias: null,
                              args: null,
                              concreteType: 'GeneralSetting',
                              kind: 'LinkedField',
                              name: 'generalSetting',
                              plural: false,
                              selections: [
                                v5 /*: any*/,
                                {
                                  alias: null,
                                  args: null,
                                  kind: 'ScalarField',
                                  name: 'availableForWork',
                                  storageKey: null,
                                },
                                {
                                  alias: null,
                                  args: null,
                                  kind: 'ScalarField',
                                  name: 'hideContactInfo',
                                  storageKey: null,
                                },
                              ],
                              storageKey: null,
                            },
                            {
                              kind: 'ClientExtension',
                              selections: [
                                {
                                  alias: null,
                                  args: null,
                                  kind: 'ScalarField',
                                  name: 'avatar_version',
                                  storageKey: null,
                                },
                              ],
                            },
                            {
                              alias: null,
                              args: null,
                              kind: 'ScalarField',
                              name: 'seaServicesAddedCount',
                              storageKey: null,
                            },
                          ],
                          storageKey: null,
                        },
                        v16 /*: any*/,
                        {
                          alias: null,
                          args: null,
                          concreteType: 'Vacancy',
                          kind: 'LinkedField',
                          name: 'vacancy',
                          plural: false,
                          selections: [
                            v5 /*: any*/,
                            {
                              alias: null,
                              args: null,
                              concreteType: 'Hire',
                              kind: 'LinkedField',
                              name: 'hires',
                              plural: true,
                              selections: [v5 /*: any*/, v17 /*: any*/],
                              storageKey: null,
                            },
                          ],
                          storageKey: null,
                        },
                        {
                          alias: null,
                          args: null,
                          kind: 'ScalarField',
                          name: 'status',
                          storageKey: null,
                        },
                        v7 /*: any*/,
                      ],
                      storageKey: null,
                    },
                    v8 /*: any*/,
                  ],
                  storageKey: null,
                },
                v9 /*: any*/,
              ],
              storageKey: null,
            },
            {
              alias: null,
              args: v10 /*: any*/,
              filters: ['vacancyId'],
              handle: 'connection',
              key: 'ListWithApplicationInviteCross_applicationInviteCross',
              kind: 'LinkedHandle',
              name: 'applicationInviteCross',
            },
          ],
        },
      ],
    },
    params: {
      cacheID: 'a5e535ca38f4567e67556b25a7e4adcb',
      id: null,
      metadata: {
        connection: [
          {
            count: 'first',
            cursor: 'after',
            direction: 'forward',
            path: ['applicationInviteCross'],
          },
        ],
      },
      name: 'ApplicationQueriesGetListOfMatchedCrewQuery',
      operationKind: 'query',
      text: 'query ApplicationQueriesGetListOfMatchedCrewQuery(\n  $vacancyId: ID!\n  $after: Cursor\n  $first: Int\n  $skip: Boolean!\n) {\n  applicationInviteCross(vacancyId: $vacancyId, first: $first, after: $after) @skip(if: $skip) {\n    edges {\n      node {\n        id\n        owner {\n          info {\n            country {\n              isoCode\n              id\n            }\n            id\n          }\n          id\n        }\n        ...ApplicationFragments\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ApplicationFragments on Application {\n  id\n  createdAt\n  vacancy {\n    id\n    hires {\n      id\n      owner {\n        id\n      }\n    }\n  }\n  owner {\n    id\n    ...ProfileFragmentsCrewProfile\n  }\n  status\n}\n\nfragment AppraisalFragmentsListWithoutDocumentPlural_profile on Appraisal {\n  ...AppraisalFragmentsOneAppraisalWithoutDocument\n}\n\nfragment AppraisalFragmentsOneAppraisalWithoutDocument on Appraisal {\n  id\n  review\n  owner {\n    id\n  }\n  seaService {\n    id\n    start\n    end\n    vessel {\n      name\n      image\n      cnISO\n      countryName\n      id\n    }\n    duty {\n      id\n      name\n    }\n  }\n}\n\nfragment CertificateFragmentsCertificateInfo on CertificateInfo {\n  id\n  expires\n  owner {\n    id\n  }\n  certificate {\n    id\n    name\n    alts\n    priority\n    neverExpires\n    kind {\n      id\n      name\n      perma\n    }\n  }\n  document {\n    id\n    urls\n    xlarge_urls\n    kind {\n      id\n      name\n      perma\n    }\n  }\n}\n\nfragment CountryFragments_info on Country {\n  id\n  isoCode\n  name\n}\n\nfragment EducationFragments on Education {\n  id\n  start\n  end\n  name\n  kind {\n    id\n    name\n    perma\n  }\n}\n\nfragment ProfileFragmentsAvatarInfo on Profile {\n  id\n}\n\nfragment ProfileFragmentsCrewProfile on Profile {\n  id\n  createdAt\n  info {\n    ...ProfileFragments_info\n    id\n  }\n  certificateInfos {\n    ...CertificateFragmentsCertificateInfo\n    id\n  }\n  seaServices {\n    ...ServiceFragmentsListPlural_profile\n    id\n  }\n  educations {\n    id\n    ...EducationFragments\n  }\n  seaServicesHighlighted {\n    ...ServiceFragmentsListPlural_profile\n    id\n  }\n  appraisals {\n    ...AppraisalFragmentsListWithoutDocumentPlural_profile\n    id\n  }\n  membership {\n    ...ProfileFragmentsOrganizationPlural_profile\n    id\n  }\n  generalSetting {\n    ...ProfileFragmentsGeneralSettings\n    id\n  }\n  ...ProfileFragmentsAvatarInfo\n  seaServicesAddedCount\n}\n\nfragment ProfileFragmentsGeneralSettings on GeneralSetting {\n  id\n  availableForWork\n  hideContactInfo\n}\n\nfragment ProfileFragmentsOrganizationPlural_profile on OrganizationMember {\n  id\n  createdAt\n  role\n  organization {\n    id\n    city\n    country {\n      id\n      isoCode\n      name\n    }\n    name\n    description\n    avatarUrl\n    size\n  }\n}\n\nfragment ProfileFragments_info on ProfileInfo {\n  id\n  firstName\n  lastName\n  bio\n  birthDate\n  avatarUrl\n  primaryDuty {\n    id\n    ...ServiceFragmentsOneDuty\n  }\n  owner {\n    id\n    createdAt\n  }\n  country {\n    ...CountryFragments_info\n    id\n  }\n  isHidden\n  yearsOfExperience\n}\n\nfragment ServiceFragments on SeaService {\n  id\n  start\n  end\n  rotations\n  description\n  vessel {\n    ...ServiceFragmentsVessel\n    id\n  }\n  duty {\n    ...ServiceFragmentsOneDuty\n    id\n  }\n  activities {\n    ...ServiceFragmentsActivities\n    id\n  }\n}\n\nfragment ServiceFragmentsActivities on Activity {\n  id\n  label\n  perma\n  timesUsed\n}\n\nfragment ServiceFragmentsListPlural_profile on SeaService {\n  ...ServiceFragments\n  id\n  start\n  end\n}\n\nfragment ServiceFragmentsOneDuty on Duty {\n  id\n  name\n  alts\n  perma\n}\n\nfragment ServiceFragmentsVessel on Vessel {\n  id\n  imo\n  name\n  grossTonnage\n  operatorName\n  kind {\n    id\n    name\n    perma\n  }\n  length\n  image\n  cnISO\n  countryName\n}\n',
    },
  };
})();

(node as any).hash = 'a9c290e3295df6f86e41b6f62a9b872e';

export default node;
